module.exports = __webpack_public_path__ + "static/img/icon-verified.bde1188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-verified.png
// module id = M1Sf
// module chunks = 0